// licenseAPI.js - API service for license management
import { fetchWithAuth } from "../apiutil";

export const licenseAPI = {
  loadLicense: async (accessToken) => {
    console.log("[licenseAPI.loadLicense] loading license");
    return fetchWithAuth("/api/license", { method: "GET" }, accessToken);
  },

  uploadLicense: async (accessToken, licenseJson) => {
    console.log("[licenseAPI.uploadLicense] uploading license", licenseJson);
    return fetchWithAuth(
      "/api/license",
      {
        method: "POST",
        body: licenseJson,
      },
      accessToken
    );
  },
};
